module.exports = __webpack_public_path__ + "5a100916f94b0babde0c92aaa8fb80d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Bold/OpenSans-Bold.ttf?v=1.1.0
// module id = 1005
// module chunks = 0